import Input from './input';
var parts = ['field', 'icon'];
export default {
    parts: parts,
    variants: Input.variants,
    defaultProps: Input.defaultProps,
};
